import { InjectionToken } from '@angular/core';
import { Occ } from '../../../../../core/occ/occ-models';
import { Converter } from '../../../../../core/util/converter.service';
import { StatisticsSoldTo } from '../model';

export const STATISTICS_SOLD_TO_NORMALIZER = new InjectionToken<Converter<Occ.Statistics, StatisticsSoldTo>>(
  'StatisticsSoldToNormalizer'
);
